import React from 'react';
import {
  PaymentTipContainer,
  ButtonContainer,
  ButtonChip,
  ChipContainer,
} from './index.view';
import { useTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import AdaptPercentField from 'components/AdaptPercentField';
import { formatTip } from 'utils/number';
import useViewModel, { CUSTOM_TIP } from './viewModel';

const TipForm = () => {
  const { t } = useTranslation();
  const { tipOptions, handleSelectTip, handleOnKeyUp, handleRemove, selectedOption } =
    useViewModel();

  return (
    <Form
      onSubmit={() => {}}
      render={({ handleSubmit, submitting, form }) => (
        <form onSubmit={handleSubmit}>
          <PaymentTipContainer>
            {selectedOption === null || selectedOption === undefined ? (
              <ChipContainer>
                {tipOptions.map((item, index) => (
                  <ButtonChip
                    key={item.value}
                    variant="outlined"
                    className={selectedOption === index ? 'active' : ''}
                    onClick={() => handleSelectTip(item.value, index, form)}
                    value={item.value}
                  >
                    {`+ ${item.value} %`}
                  </ButtonChip>
                ))}
              </ChipContainer>
            ) : null}
            {selectedOption === CUSTOM_TIP ? (
              <ButtonContainer>
                <Field
                  name="tip_percentage"
                  disabled={submitting}
                  component={AdaptPercentField}
                  data-testid="amount-field"
                  parse={formatTip}
                  onKeyUp={handleOnKeyUp}
                />
              </ButtonContainer>
            ) : null}
          </PaymentTipContainer>
        </form>
      )}
    />
  );
};

export default TipForm;
